import "core-js/modules/web.dom.iterable";
import request from "@/util/http";
import qs from "qs"; //"新增部门"

export function addDept(obj) {
  return request({
    url: "/admin/dept",
    method: "post",
    data: obj
  });
} //"删除部门"

export function deleteDept(id) {
  return request({
    url: "/admin/dept/" + id,
    method: "delete"
  });
} //"通过id查找"

export function getDeptById(id) {
  return request({
    url: "/admin/dept/" + id,
    method: "get"
  });
} //批量删除部门

export function deleteBatchDept(query) {
  var params = "";
  query.forEach(function (item) {
    params += "ids=".concat(item, "&");
  });
  return request({
    url: "/admin/dept/batch",
    method: "delete",
    headers: {
      "content-type": "application/x-www-form-urlencoded"
    },
    data: params
  });
} //"修改部门"

export function updateDept(obj) {
  return request({
    url: "/admin/dept",
    method: "put",
    data: obj
  });
} //"获取树状菜单"

export function fetchDeptTree(query) {
  return request({
    url: "/admin/dept/tree",
    method: "get",
    params: query
  });
} //"获取树状菜单"

export function studentTreeUrl(query) {
  return request({
    url: "/admin/dept/courseDeptTree",
    method: "get",
    params: query
  });
} //获取用户管辖树状菜单",

export function fetchScopeDeptTree(query) {
  return request({
    url: "/admin/dept/user-tree",
    method: "get",
    params: query
  });
} //获得部门分页",

export function fetchDeptList(query) {
  return request({
    url: "/admin/dept/page",
    method: "get",
    params: query
  });
} //保存用户部门负责人",

export function saveDepartCharge(query) {
  return request({
    url: "/admin/dept/saveDeptCharges",
    method: "get",
    params: query
  });
} //获取用户部门负责人",

export function getDepartCharge(query) {
  return request({
    url: "/admin/dept/getDeptCharges/",
    method: "get",
    params: query
  });
}
export function getSubDept(id) {
  return request({
    url: "/admin/dept/getByPid?parentId=" + id,
    method: "get"
  });
}